import { IPackagingOrder } from './IPackaging'
import { StockCard } from './IStockCard'

export interface IPackagingRequest {
  packagingRequestId: string
  packagingRequestDisplayId: string
  inOutDirection: string
  sourceOrDestination: string
  batchNumber: string
  stockCard: StockCard | null
  packagings: IPackagingOrder[]
  notes: string
  createdAt: Date | null
}

export class PackagingRequest {
  packagingRequestId: string
  packagingRequestDisplayId: string
  inOutDirection: string
  sourceOrDestination: string
  batchNumber: string
  stockCard: StockCard | null
  packagings: IPackagingOrder[]
  notes: string
  createdAt: Date | null
  constructor({
    packagingRequestId,
    packagingRequestDisplayId,
    inOutDirection,
    stockCard,
    sourceOrDestination,
    batchNumber,
    packagings,
    notes,
    createdAt,
  }: Partial<IPackagingRequest> = {}) {
    this.packagingRequestId = packagingRequestId ?? ''
    this.packagingRequestDisplayId = packagingRequestDisplayId ?? ''
    this.inOutDirection = inOutDirection ?? ''
    this.stockCard = stockCard ?? null
    this.sourceOrDestination = sourceOrDestination ?? ''
    this.batchNumber = batchNumber ?? ''
    this.packagings = packagings ?? []
    this.notes = notes ?? ''
    this.createdAt = createdAt ?? null
  }
}

export enum PackagingRequestSourceOrDestination {
  rnd = 'RnD',
  adjustment = 'Adjustment',
  return = 'customer return',
  inNoCost = 'in no cost',
  outNoCost = 'out no cost',
  fillingAdditional = 'filling additional',
  productionReturnPackaging = 'productionReturnPackaging',
  batchRework = 'batchRework',
  stjTukarKemasan = 'stj tukar kemasan',
  pakMul = 'pak mul',
  purchaseReturn = 'purchase return',
  packing = 'packing',
}

